import Splide from '@splidejs/splide';

const selectors = {
  announcementCarousel: '[data-announcement-bar-carousel]',
};

export default class AnnouncementBar {
  constructor(section) {
    this.section = section;
    this.initAnnouncementCarousel();
  }

  initAnnouncementCarousel = () => {
    const announcementCarouselList = this.section.el.querySelectorAll(
      selectors.announcementCarousel,
    );

    announcementCarouselList.forEach(carousel => {
      const announcementCarousel = new Splide(carousel, {
        type: 'loop',
        autoplay: true,
        interval: 5000,
        pauseOnHover: true,
        perPage: 1,
        pagination: false,
        arrows: true,
      });

      announcementCarousel.mount();
    });
  };
}